import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGovDotUkComponent } from './simple-icons-gov-dot-uk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGovDotUkComponent ],
    exports:      [ SimpleIconsGovDotUkComponent ],
    bootstrap:    []
})
export class SimpleIconsGovDotUkModule {}
